import gql from 'graphql-tag';
/** Optionally reverse the result sort order from `HEIGHT_DESC` (default) to `HEIGHT_ASC`. */
export var SortOrder;
(function (SortOrder) {
    /** Results are sorted by the transaction block height in ascending order, with the oldest transactions appearing first, and the most recent and pending/unconfirmed appearing last. */
    SortOrder["HeightAsc"] = "HEIGHT_ASC";
    /** Results are sorted by the transaction block height in descending order, with the most recent and unconfirmed/pending transactions appearing first. */
    SortOrder["HeightDesc"] = "HEIGHT_DESC";
})(SortOrder || (SortOrder = {}));
/** The operator to apply to a tag value. */
export var TagOperator;
(function (TagOperator) {
    /** Equal */
    TagOperator["Eq"] = "EQ";
    /** Not equal */
    TagOperator["Neq"] = "NEQ";
})(TagOperator || (TagOperator = {}));
export const GetBlocksDocument = gql `
    query getBlocks($ids: [ID!], $height: BlockFilter, $first: Int = 10, $after: String, $sort: SortOrder = HEIGHT_DESC) {
  blocks(ids: $ids, height: $height, first: $first, after: $after, sort: $sort) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        timestamp
        height
        previous
      }
    }
  }
}
    `;
export const GetTransactionsDocument = gql `
    query getTransactions($ids: [ID!], $owners: [String!], $recipients: [String!], $tags: [TagFilter!], $bundledIn: [ID!], $block: BlockFilter, $first: Int = 10, $after: String, $sort: SortOrder = HEIGHT_DESC) {
  transactions(
    ids: $ids
    owners: $owners
    recipients: $recipients
    tags: $tags
    bundledIn: $bundledIn
    block: $block
    first: $first
    after: $after
    sort: $sort
  ) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        block {
          height
          id
          timestamp
        }
        recipient
        owner {
          address
          key
        }
        fee {
          winston
          ar
        }
        quantity {
          winston
          ar
        }
        tags {
          name
          value
        }
        data {
          size
          type
        }
        bundledIn {
          id
        }
      }
    }
  }
}
    `;
const defaultWrapper = (action, _operationName) => action();
export function getSdk(client, withWrapper = defaultWrapper) {
    return {
        getBlocks(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetBlocksDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getBlocks');
        },
        getTransactions(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(GetTransactionsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'getTransactions');
        }
    };
}
//# sourceMappingURL=generated.js.map